import { createSlice } from "@reduxjs/toolkit";
 
const initialData = { pageTitle: 'Tenant Management System', htmlTitle: 'TMS', assetsBaseUrl: process.env.REACT_APP_ASSETS_BASE_URL};

const generalSlice = createSlice({
  name: "login",
  initialState: initialData,
  reducers: {
    updateData(state, action) {
      state.pageTitle = action.payload.pageTitle;
      state.htmlTitle = action.payload.htmlTitle;
    },
    updatePageTitle(state, action) {
      document.title = action.payload.title + ' - '  + state.pageTitle;
    },
  },
});

export const generalActions = generalSlice.actions;

export default generalSlice.reducer;
